import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { Speakers } from 'components';

// Multi-stage event pages switch between stages client-side, so unlike the single event template
// (which filters speakers by eventId in its page query) we fetch all speakers once and filter at
// runtime for the currently selected stage.
function MultiEventSpeakers({ eventId, isEditor, colors }) {
  const data = useStaticQuery(graphql`
    query {
      staticSpeakers: allSpeaker {
        edges {
          node {
            speakerId
            name
            company
            titleOrRole
            presentationTitles
            bio
            staticAvatar {
              publicURL
              childImageSharp {
                gatsbyImageData(
                  layout: CONSTRAINED
                  formats: [AUTO, WEBP]
                  width: 738
                  height: 738
                  placeholder: TRACED_SVG
                  transformOptions: { cropFocus: CENTER }
                )
              }
            }
            socials {
              facebook
              twitter
              instagram
              linkedIn
            }
            orders
            eventsSpeakingAt
            dateCreated
            lastModified
          }
        }
      }
    }
  `);
  const staticSpeakers = data?.staticSpeakers?.edges?.map(({ node: speaker }) => ({
    // GraphQL does not support non 32-bit signed integer values, which are essentially what
    // dateCreated and lastModified are stored as in Firebase. So in the createSchemaCustomization()
    // in gatsby-node.js they're coerced to Strings and we convert those strings back to Numbers below.
    ...speaker,
    dateCreated: Number(speaker.dateCreated),
    lastModified: Number(speaker.lastModified)
  }));

  const filteredStaticSpeakers =
    staticSpeakers?.filter((speaker) => speaker.eventsSpeakingAt?.includes(eventId)) || [];

  return isEditor || filteredStaticSpeakers.length ? (
    <Speakers staticSpeakers={filteredStaticSpeakers} eventId={eventId} colors={colors} />
  ) : null;
}

export default MultiEventSpeakers;
